import {
  getDatabaseUrl,
  getFreiburgerUrl,
  getInternalApiKey,
  getJwtConfig,
  getLivekitConfig,
  getMeetPublicBaseUrl,
  getOdooInternalApiBaseUrl,
  getOdooInternalApiKey,
  getSocketPublicEndpoint,
  getSocketWebhookSigningSecret,
  getTimerSeconds
} from "@/lib/env";

/**
 * Configuration interface and object for environment variables.
 */
export interface Config {
  BASE_URL: string;
  DATABASE_URL: string;
  INTERNAL_API_KEY: string;
  TIMER_SECONDS: number;

  FREIBURGER_URL: string;
  ODOO_INTERNAL_API_BASE_URL: string;
  ODOO_INTERNAL_API_KEY: string;
  NEXT_PUBLIC_SOCKET_ENDPOINT: string;
  SOCKET_WEBHOOK_SIGNING_SECRET: string;

  LIVEKIT_URL: string;
  LIVEKIT_API_KEY: string;
  LIVEKIT_API_SECRET: string;

  JWT_SECRET: string;
  JWT_EXPIRES_IN: string;
}

const livekit = getLivekitConfig();
const jwt = getJwtConfig();

export const Config: Config = {
  BASE_URL: getMeetPublicBaseUrl(),
  INTERNAL_API_KEY: getInternalApiKey(),
  TIMER_SECONDS: getTimerSeconds(),
  DATABASE_URL: getDatabaseUrl(),

  FREIBURGER_URL: getFreiburgerUrl(),
  ODOO_INTERNAL_API_KEY: getOdooInternalApiKey(),
  ODOO_INTERNAL_API_BASE_URL: getOdooInternalApiBaseUrl(),
  NEXT_PUBLIC_SOCKET_ENDPOINT: getSocketPublicEndpoint(),
  SOCKET_WEBHOOK_SIGNING_SECRET: getSocketWebhookSigningSecret(),

  LIVEKIT_URL: livekit.url,
  LIVEKIT_API_KEY: livekit.apiKey,
  LIVEKIT_API_SECRET: livekit.apiSecret,

  JWT_SECRET: jwt.secret,
  JWT_EXPIRES_IN: jwt.expiresIn
};

// Re-export token utilities from shared for backward compatibility
export { getOdooToken, getMeetToken } from "@shared/utils/tokens";
